<div class="w-25 customs-slider-container">
  <input type="range" class="slider-customs" [min]="min" [max]="max" [value]="value" (input)="valueChanged($event)" id="customRange">
</div>
